import PrivateRoute from '@Components/ConditionalRoutes/PrivateRoute';
import RouteErrorBoundary from '@Components/ErrorBoundary/RouteErrorBoundary';
import { useTypedSelector } from '@Features/store';
import Login from '@Pages/Login';
import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';
import { LiveWebinar } from '@Pages/LiveWebinar/LiveWebinar';

const DebugRouter = ({ children }: React.PropsWithChildren<any>) => {
	return children;
};
const RoutesLayout = () => {
	const { isAuth } = useTypedSelector((state) => state.auth);
	const location = useLocation();
	return (
		// No Router here: App.tsx already provides <Router history={history}>.
		// Nesting a second <BrowserRouter> gave it a separate history instance,
		// so QueryParamProvider and Layout read the outer history while these
		// routes matched the inner one.
		<DebugRouter>
			<RouteErrorBoundary resetKey={location.pathname}>
				<Switch>
					<Route exact path={'/'}>
						{/* Authenticated visitors previously redirected to `pathname`,
						    which at "/" is "/" - a no-op that rendered a blank page. */}
						{isAuth ? <Redirect to="/dashboard" /> : <Redirect to="/login" />}
					</Route>
					<Route path={'/login'} render={() => <Login />} />
					<Route path={'/webinar'} component={LiveWebinar} />
					<PrivateRoute path={'/dashboard'}>
						<DashboardLayout />
					</PrivateRoute>
				</Switch>
			</RouteErrorBoundary>
		</DebugRouter>
	);
};

export default RoutesLayout;
